import {Injectable} from '@angular/core';
import {KeycloakAuthGuard, KeycloakService} from 'keycloak-angular';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot} from '@angular/router';
import {SECURED__WIZARD} from '@core/routes/app-routes';
import {KeycloakApplicationRolesEnum} from '@core/modules/rest/user/enums/keycloak-application-roles.enum';

@Injectable({
    providedIn: 'root',
})
export class AdminGuard extends KeycloakAuthGuard {
    constructor(
        protected readonly router: Router,
        protected readonly keycloak: KeycloakService
    ) {
        super(router, keycloak);
    }

    public async isAccessAllowed(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Promise<boolean> {
        // Force the user to log in if currently unauthenticated.
        if (!this.authenticated) {
            await this.keycloak.login({
                redirectUri: SECURED__WIZARD
            });
        }
        // Get the roles required from the route.
        const requiredRoles = [];
        requiredRoles.push(KeycloakApplicationRolesEnum.SUPERADMIN.toLowerCase());
        requiredRoles.push(KeycloakApplicationRolesEnum.ADMIN.toLowerCase());

        // Allow the user to proceed if no additional roles are required to access the route.
        if (!(requiredRoles instanceof Array) || requiredRoles.length === 0) {
            return true;
        }

        // Allow the user to proceed if all the required roles are present.
        return requiredRoles.some((role) => this.roles.includes(role));
    }
}
